function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { MenuDropDown } from 'dropdown';
import Popover from 'popover';
import Trix from 'trix';
import '@rails/actiontext';
import './rich_text.scss';
import CreateButton from '../button';

for (var i = 1; i <= 6; i++) {
  Trix.config.blockAttributes["heading".concat(i)] = {
    tagName: "h".concat(i),
    terminal: true,
    breakOnReturn: true,
    group: false
  };
}

Trix.config.blockAttributes["default"].breakOnReturn = true;
Trix.config.blockAttributes.quote.breakOnReturn = false;
Trix.config.blockAttributes.quote.nestable = false;
Trix.config.blockAttributes.quote.group = true;

var RichTextToolbar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(RichTextToolbar, _HTMLElement);

  var _super = _createSuper(RichTextToolbar);

  function RichTextToolbar(trix) {
    var _this;

    _classCallCheck(this, RichTextToolbar);

    _this = _super.call(this);
    _this.trix = trix;
    var urlTemplate = trix.getAttribute('data-attachments-blob-template');

    if (urlTemplate && urlTemplate.length > 0) {
      trix.dataset.blobUrlTemplate = urlTemplate;
    }

    var uploadPath = trix.getAttribute('data-attachments-blob-upload-path');

    if (uploadPath && uploadPath.length > 0) {
      trix.dataset.directUploadUrl = uploadPath;
    }

    _this.setupElements();

    _this.setupEvents();

    _this.editorChanged();

    return _this;
  }

  _createClass(RichTextToolbar, [{
    key: "editor",
    get: function get() {
      return this.trix.editor;
    }
  }, {
    key: "focusEditor",
    value: function focusEditor() {
      var range = this.editor.getSelectedRange();
      this.editor.setSelectedRange(range);
    } ////////// Actions

  }, {
    key: "toggleStyleAttribute",
    value: function toggleStyleAttribute(attribute) {
      this.editor.recordUndoEntry(attribute);

      if (this.editor.attributeIsActive(attribute)) {
        this.editor.deactivateAttribute(attribute);
      } else {
        this.editor.activateAttribute(attribute);
      }

      this.focusEditor();
    }
  }, {
    key: "toggleBlockAttribute",
    value: function toggleBlockAttribute(attribute) {
      this.editor.recordUndoEntry(attribute);

      if (this.editor.attributeIsActive(attribute)) {
        this.editor.deactivateAttribute(attribute);
      } else {
        this.clearBlockAttribute();
        this.editor.activateAttribute(attribute);
      }
    }
  }, {
    key: "clearBlockAttribute",
    value: function clearBlockAttribute() {
      var _this2 = this;

      var block = this.editor.composition.getBlock();

      if (block.attributes.length > 0) {
        block.attributes.forEach(function (attribute) {
          return _this2.editor.deactivateAttribute(attribute);
        });
      }
    }
  }, {
    key: "decreaseNestingLevel",
    value: function decreaseNestingLevel() {
      if (this.editor.canDecreaseNestingLevel()) {
        this.editor.recordUndoEntry('outdent');
        this.editor.decreaseNestingLevel();
      }
    }
  }, {
    key: "increaseNestingLevel",
    value: function increaseNestingLevel() {
      if (this.editor.canIncreaseNestingLevel()) {
        this.editor.recordUndoEntry('indent');
        this.editor.increaseNestingLevel();
      }
    }
  }, {
    key: "showLinkPopover",
    value: function showLinkPopover() {
      var _this3 = this;

      var popover = new Popover({
        removeOnHide: true
      });
      popover.title = 'Edit Link'; // Active Link

      this.editor.composition.expandSelectionForEditing();
      var currentHref = this.editor.composition.currentAttributes.href || 'https://'; // Form

      var form = document.createElement('form');
      form.classList.add('form--standard');
      var field = document.createElement('div');
      field.classList.add('form__field');
      field.classList.add('form__field--url');
      var label = document.createElement('div');
      label.classList.add('form__field__label');
      label.innerHTML = '<label for="rich_text_url">Url</label>';
      var input = document.createElement('input');
      input.type = 'url';
      input.id = 'rich_text_url';
      input.classList.add('form__field__input');
      input.value = currentHref;
      field.appendChild(label);
      field.appendChild(input);
      form.appendChild(field); // Buttons

      var buttons = document.createElement('div');
      buttons.classList.add('form__buttons');
      var linkButton = CreateButton({
        tag: 'button',
        text: 'Link',
        type: 'submit'
      });
      linkButton.addEventListener('click', function (_event) {
        form.button = 'link';
      });
      var unlinkButton = CreateButton({
        tag: 'button',
        text: 'Unlink',
        type: 'submit'
      });
      unlinkButton.addEventListener('click', function (_event) {
        form.button = 'unlink';
      });
      buttons.appendChild(linkButton);
      buttons.appendChild(unlinkButton);
      form.appendChild(buttons); // Submit

      form.addEventListener('submit', function (event) {
        _this3.editor.recordUndoEntry('link');

        if (form.button === 'unlink') {
          _this3.editor.deactivateAttribute('href');
        } else {
          var url = input.value;

          _this3.editor.activateAttribute('href', url);
        }

        popover.hide();
        event.preventDefault();
        return false;
      }); //

      popover.body.appendChild(form);
      popover.show();
    }
  }, {
    key: "showInjectionPopover",
    value: function showInjectionPopover(path) {
      var _this4 = this;

      var popover = new Popover({
        removeOnHide: true
      });
      popover._captureContent = popover.captureContent;

      popover.captureContent = function () {
        popover._captureContent();

        popover.querySelectorAll('[data-inject-sgid]').forEach(function (button) {
          button.addEventListener('click', function (_event) {
            var sgid = button.getAttribute('data-inject-sgid');
            var content = button.getAttribute('data-inject-content');
            var attachment = new Trix.Attachment({
              sgid: sgid,
              content: content
            });

            _this4.editor.insertAttachment(attachment);

            popover.hide();
          });
        });
      };

      popover.loadContent("/".concat(path, "/inject?input_id=").concat(this.id));
      popover.show();
    }
  }, {
    key: "showFilePicker",
    value: function showFilePicker() {
      var _this5 = this;

      var input = Trix.makeElement('input', {
        type: 'file',
        hidden: true,
        id: Trix.config.input.fileInputId
      });

      if (!this.attachmentAnyFileType) {
        input.accept = this.attachmentFileTypes.map(function (type) {
          return type === 'video/*' ? 'video/*,video/mp4,video/x-m4v' : type;
        }).join(',');
      }

      input.addEventListener('change', function () {
        _this5.editor.insertFiles(input.files);

        Trix.removeNode(input);
      });
      Trix.removeNode(document.getElementById(Trix.config.input.fileInputId));
      document.body.appendChild(input);
      input.click();
    } ////////// Elements

  }, {
    key: "setupElements",
    value: function setupElements() {
      var _this6 = this;

      // Text Attributes
      this.boldButton = this.createButton({
        icon: 'editor_bold',
        title: 'Bold'
      });
      this.italicButton = this.createButton({
        icon: 'editor_italic',
        title: 'Italic'
      });
      this.strikethruButton = this.createButton({
        icon: 'editor_strikethru',
        title: 'Strikethrough'
      });
      this.linkButton = this.createButton({
        icon: 'editor_link',
        title: 'Add Link'
      }); // Headings

      this.headingButton = this.createButton({
        icon: 'editor_heading',
        title: 'Heading'
      });
      this.headingButton.classList.add('dropdown__anchor');
      this.headingDropdown = new MenuDropDown(this.headingButton, [{
        title: 'Heading 1',
        action: function action() {
          _this6.headingPressed(1);
        }
      }, {
        title: 'Heading 2',
        action: function action() {
          _this6.headingPressed(2);
        }
      }, {
        title: 'Heading 3',
        action: function action() {
          _this6.headingPressed(3);
        }
      }, {
        title: 'Heading 4',
        action: function action() {
          _this6.headingPressed(4);
        }
      }, {
        title: 'Heading 5',
        action: function action() {
          _this6.headingPressed(5);
        }
      }, {
        title: 'Heading 6',
        action: function action() {
          _this6.headingPressed(6);
        }
      }]); // Block Attributes

      this.quoteButton = this.createButton({
        icon: 'editor_quote',
        title: 'Quote'
      });
      this.codeButton = this.createButton({
        icon: 'editor_code',
        title: 'Code'
      });
      this.bulletsButton = this.createButton({
        icon: 'editor_bullets',
        title: 'Bullets'
      });
      this.numbersButton = this.createButton({
        icon: 'editor_numbers',
        title: 'Numbers'
      });
      this.outdentButton = this.createButton({
        icon: 'editor_outdent',
        title: 'Decrease Level'
      });
      this.indentButton = this.createButton({
        icon: 'editor_indent',
        title: 'Increase Level'
      }); // Attachments

      var attachmentMenuItems = [];
      var injectables = this.trix.getJsonAttribute('data-injectables');

      if (injectables && injectables.length > 0) {
        injectables.forEach(function (injectable) {
          attachmentMenuItems.push({
            title: injectable.title,
            action: function action() {
              _this6.showInjectionPopover(injectable.path);
            }
          });
        });
      }

      var fileTypes = this.trix.getJsonAttribute('data-file-types');

      if (fileTypes && fileTypes.length > 0) {
        this.attachmentFileTypes = fileTypes;
        var fileTitle = 'File';

        if (fileTypes.length === 1) {
          var type = fileTypes[0];

          if (type.match(/^image\//)) {
            fileTitle = 'Image';
          } else if (type.match(/^video\//)) {
            fileTitle = 'Video';
          } else if (type === '*' || type === '*/*') {
            this.attachmentAnyFileType = true;
          }
        }

        attachmentMenuItems.push({
          title: fileTitle,
          action: function action() {
            _this6.showFilePicker();
          }
        });
      } else {
        this.attachmentFileTypes = [];
      }

      if (attachmentMenuItems.length > 0) {
        this.attachmentButton = this.createButton({
          icon: 'editor_inject',
          title: 'Inject Content'
        });
        this.attachmentButton.classList.add('dropdown__anchor');
        this.attachmentDropdown = new MenuDropDown(this.attachmentButton, attachmentMenuItems);
      } //


      this.undoButton = this.createButton({
        icon: 'editor_undo',
        title: 'Undo'
      });
      this.redoButton = this.createButton({
        icon: 'editor_redo',
        title: 'Redo'
      }); // Grouping

      var groups = [[this.boldButton, this.italicButton, this.strikethruButton, this.linkButton], [this.headingDropdown, this.quoteButton, this.codeButton, this.bulletsButton, this.numbersButton, this.outdentButton, this.indentButton]];

      if (this.attachmentDropdown) {
        groups.push([this.attachmentDropdown]);
      }

      groups.push([this.undoButton, this.redoButton]);
      groups.forEach(function (group) {
        var buttonGroup = document.createElement('div');
        buttonGroup.classList.add('button-group');
        group.forEach(function (button) {
          if (button) {
            buttonGroup.appendChild(button);
          }
        });

        _this6.appendChild(buttonGroup);
      });
    }
  }, {
    key: "createButton",
    value: function createButton(options) {
      options.style = 'outline';
      options.size = 'small';
      return CreateButton(options);
    } // Events

  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this7 = this;

      this.trix.addEventListener('trix-change', function (_event) {
        return _this7.editorChanged();
      });
      this.trix.addEventListener('trix-selection-change', function (_event) {
        return _this7.editorSelectionChanged();
      });
      this.boldButton.addEventListener('click', function (_event) {
        return _this7.boldPressed();
      });
      this.italicButton.addEventListener('click', function (_event) {
        return _this7.italicPressed();
      });
      this.strikethruButton.addEventListener('click', function (_event) {
        return _this7.strikethruPressed();
      });
      this.linkButton.addEventListener('click', function (_event) {
        return _this7.linkPressed();
      });
      this.quoteButton.addEventListener('click', function (_event) {
        return _this7.quotePressed();
      });
      this.codeButton.addEventListener('click', function (_event) {
        return _this7.codePressed();
      });
      this.bulletsButton.addEventListener('click', function (_event) {
        return _this7.bulletsPressed();
      });
      this.numbersButton.addEventListener('click', function (_event) {
        return _this7.numbersPressed();
      });
      this.outdentButton.addEventListener('click', function (_event) {
        return _this7.outdentPressed();
      });
      this.indentButton.addEventListener('click', function (_event) {
        return _this7.indentPressed();
      });
      this.undoButton.addEventListener('click', function (_event) {
        return _this7.undoPressed();
      });
      this.redoButton.addEventListener('click', function (_event) {
        return _this7.redoPressed();
      });
    }
  }, {
    key: "editorChanged",
    value: function editorChanged() {
      this.updateStyleState();
      this.updateBlockState();
      this.updateUndoState();
    }
  }, {
    key: "editorSelectionChanged",
    value: function editorSelectionChanged() {
      this.updateStyleState();
      this.updateBlockState();
    }
  }, {
    key: "boldPressed",
    value: function boldPressed() {
      this.toggleStyleAttribute('bold');
    }
  }, {
    key: "italicPressed",
    value: function italicPressed() {
      this.toggleStyleAttribute('italic');
    }
  }, {
    key: "strikethruPressed",
    value: function strikethruPressed() {
      this.toggleStyleAttribute('strike');
    }
  }, {
    key: "linkPressed",
    value: function linkPressed() {
      this.showLinkPopover();
    } // Block Elements

  }, {
    key: "headingPressed",
    value: function headingPressed(number) {
      this.toggleBlockAttribute("heading".concat(number));
    }
  }, {
    key: "quotePressed",
    value: function quotePressed() {
      this.toggleBlockAttribute('quote');
    }
  }, {
    key: "codePressed",
    value: function codePressed() {
      this.toggleBlockAttribute('code');
    }
  }, {
    key: "bulletsPressed",
    value: function bulletsPressed() {
      this.toggleBlockAttribute('bullet');
    }
  }, {
    key: "numbersPressed",
    value: function numbersPressed() {
      this.toggleBlockAttribute('number');
    }
  }, {
    key: "outdentPressed",
    value: function outdentPressed() {
      this.decreaseNestingLevel();
    }
  }, {
    key: "indentPressed",
    value: function indentPressed() {
      this.increaseNestingLevel();
    } // Undo

  }, {
    key: "undoPressed",
    value: function undoPressed() {
      if (this.editor.canUndo()) {
        this.editor.undo();
      }
    }
  }, {
    key: "redoPressed",
    value: function redoPressed() {
      if (this.editor.canRedo()) {
        this.editor.redo();
      }
    } // State

  }, {
    key: "updateStyleState",
    value: function updateStyleState() {
      this.boldButton.classList.toggle('button--active', this.editor.attributeIsActive('bold'));
      this.italicButton.classList.toggle('button--active', this.editor.attributeIsActive('italic'));
      this.strikethruButton.classList.toggle('button--active', this.editor.attributeIsActive('strike'));
      this.linkButton.classList.toggle('button--active', this.editor.attributeIsActive('href'));
    }
  }, {
    key: "updateBlockState",
    value: function updateBlockState() {
      var _this8 = this;

      var headingActive = ['heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6'].some(function (h) {
        return _this8.editor.attributeIsActive(h);
      });
      this.headingButton.classList.toggle('button--active', headingActive);
      this.quoteButton.classList.toggle('button--active', this.editor.attributeIsActive('quote'));
      this.codeButton.classList.toggle('button--active', this.editor.attributeIsActive('code'));
      this.bulletsButton.classList.toggle('button--active', this.editor.attributeIsActive('bullet'));
      this.numbersButton.classList.toggle('button--active', this.editor.attributeIsActive('number'));

      if (this.editor.canDecreaseNestingLevel()) {
        this.outdentButton.removeAttribute('disabled');
      } else {
        this.outdentButton.setAttribute('disabled', '');
      }

      if (this.editor.canIncreaseNestingLevel()) {
        this.indentButton.removeAttribute('disabled');
      } else {
        this.indentButton.setAttribute('disabled', '');
      }
    }
  }, {
    key: "updateUndoState",
    value: function updateUndoState() {
      if (this.editor.canUndo()) {
        this.undoButton.removeAttribute('disabled');
      } else {
        this.undoButton.setAttribute('disabled', '');
      }

      if (this.editor.canRedo()) {
        this.redoButton.removeAttribute('disabled');
      } else {
        this.redoButton.setAttribute('disabled', '');
      }
    }
  }]);

  return RichTextToolbar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

window.customElements.define('rich-text-toolbar', RichTextToolbar); // TODO

document.addEventListener('trix-before-initialize', function (ev) {
  ev.target.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      if (!this.editor.attributeIsActive('quote')) {
        this.editor.composition.insertBlockBreak();
        event.preventDefault();
      }
    }
  });
});
document.addEventListener('trix-initialize', function (event) {
  var toolbar = new RichTextToolbar(event.target);
  toolbar.id = "".concat(event.target.id, "_toolbar");
  event.target.parentElement.insertBefore(toolbar, event.target);
  event.target.richTextToolbar = toolbar;
});
document.addEventListener("trix-attachment-add", function (event) {
  var toolbar = event.target.richTextToolbar;
  var attachmentAttributes = event.attachment.attachment.attributes;

  if (!!attachmentAttributes.values.sgid && attachmentAttributes.values.sgid.length > 0) {
    // Custom Attachment, allow
    return;
  }

  if (!!attachmentAttributes.values.url && attachmentAttributes.values.url.length > 0) {
    AlertBox.showAlert({
      color: 'red',
      title: 'Unsupported File Type',
      body: 'External files are not supported'
    });
    event.attachment.remove();
    event.preventDefault();
    return false;
  }

  var file = event.attachment.file;

  if (file) {
    if (!toolbar.attachmentFileTypes || toolbar.attachmentFileTypes == 0) {
      event.attachment.remove();
      event.preventDefault();
      return false;
    }

    var acceptFile = false;
    var uploadedFileType = file.type;

    if (toolbar.attachmentAnyFileType) {
      acceptFile = true;
    } else {
      toolbar.attachmentFileTypes.forEach(function (fileType) {
        var match = fileType.match(/^(.+)\/\*$/);

        if (match) {
          if (uploadedFileType.startsWith(match[1])) {
            acceptFile = true;
          }
        } else {
          if (uploadedFileType == fileType) {
            acceptFile = true;
          }
        }
      });
    }

    if (!acceptFile) {
      AlertBox.showAlert({
        color: 'red',
        title: 'Unsupported File Type',
        body: ''
      });
      event.attachment.remove();
      event.preventDefault();
      return false;
    } // Allow


    return;
  }
});